module.exports = __webpack_public_path__ + "assets/img/driver-btn-2f307520.png";